module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.entity,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "mobileNo"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.entity.mobileNo),
      callback: function($$v) {
        _vm.$set(_vm.entity, "mobileNo", $$v)
      },
      expression: "entity.mobileNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "realname"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.entity.realname),
      callback: function($$v) {
        _vm.$set(_vm.entity, "realname", $$v)
      },
      expression: "entity.realname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.entity.remark),
      callback: function($$v) {
        _vm.$set(_vm.entity, "remark", $$v)
      },
      expression: "entity.remark"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce6b9596","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/act/promotionDispatchUser/Form.vue
// module id = 353
// module chunks = 0